
import { getAccountsById } from 'data/accounts/retrievers';

// -------------------------------------------------------
// isLoanAccountFromId
//
export function isLoanAccountFromId(id, state) {

  const accountsById = getAccountsById(state);

  if (accountsById) {
    return isLoanAccount(accountsById.get(id));
  }
  return false;
}

// -------------------------------------------------------
// isInvestmentAccountFromId
//
export function isInvestmentAccountFromId(id, state) {

  const accountsById = getAccountsById(state);

  if (accountsById) {
    return isInvestmentAccount(accountsById.get(id));
  }
  return false;
}

// -------------------------------------------------------
// isBankAccountFromId
//
export function isBankAccountFromId(id, state) {

  const accountsById = getAccountsById(state);

  if (accountsById) {
    return isBankAccount(accountsById.get(id));
  }
  return false;
}
// -------------------------------------------------------
// isActiveConnectedAccount
//
export function isActiveConnectedAccountFromId(id, state) {

  const accountsById = getAccountsById(state);

  if (accountsById) {
    return isActiveConnectedAccount(accountsById.get(id));
  }
  return false;
}


// -------------------------------------------------------
// isBankAccount
//
export function isBankAccount(acct) {
  return acct && acct.type === 'BANK';
}

// -------------------------------------------------------
// isLoanAccount
//
export function isLoanAccount(acct) {
  return acct && acct.type === 'LOAN';
}

// -------------------------------------------------------
// isInvestmentAccount
//
export function isInvestmentAccount(acct) {
  return acct && acct.type === 'INVESTMENT';
}

// -------------------------------------------------------
// isActiveConnectedAccount
//
export function isActiveConnectedAccount(acct) {
  return acct && acct.aggregators && (acct.aggregators.size > 0);
}

// -------------------------------------------------------
// Convert the transaction setting to a number of days
// but of course, does not work for number of occurrences
//
export function getReminderSettingInDays(recurringTxn) {
  if (recurringTxn) {
    switch(recurringTxn.unitType) {
      case 'MONTHS':
        // this is not really accurate  TODO: Use date calcs to be truly accurate
        return (recurringTxn.value * 31);
      case 'OCCURRENCES':
        return -1 * recurringTxn.value;  // should resolve to 0 or -1

      default:
        return recurringTxn.value || 0;
    }
  }
  return 0;
}
// -------------------------------------------------------
// Convert back, dependent upon dataset type
//
export function getReminderObjectFromDays(days, _isWindows = true) {

  if (days < 0) {
    return { unitType: 'OCCURRENCES', value: 1 };
  }
  if (days === 0) {
    return { unitType: 'OCCURRENCES', value: 0 };
  }
  /* MAC is now only sending DAYS
  if (!isWindows && days > 90) {
    return { unitType: 'MONTHS', value: Math.round(days/31) }
  }
  */
  return { unitType: 'DAYS', value: days }
}

// This is hacky and could be moved to feaeture-flags if we were to send entitlements to launch darkly. Since account
// and account types are so fundamental in our system, it is unlikely to change very often so not sure we should
// worry about making this more flexible or less brittle.
//
export let isAccountNodeSelectable = null;  // eslint-disable-line import/no-mutable-exports

/////////////////////////////////////
//////////////////////////////////////////////////
///////////////////////////
////////////////////////////
/////////////////////////
/////////////////////////
///////////////////////////
///////////////////////////////
/////////////////////////
////////////////////////////////
////////////////////////////////
//////////////////////////

/////////////////////////////////////////////
////////////////////////////
/////////////////
///

/////////////////////////////////////////////////////////////////////////
/////////////////////
////////////////////////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
////////
isAccountNodeSelectable = (node, currentNode, tier) => {
  const { qcsType } = node;
  let qcsTypeIsSupported =
    qcsType === 'BANK' ||
    qcsType === 'CASH' ||
    qcsType === 'CREDIT';

  if (!qcsTypeIsSupported && !['US_QUICKEN_STARTER','CA_QUICKEN_CASHMANAGER'].includes(tier.id)) {
    qcsTypeIsSupported =
      qcsType === 'OTHER_ASSET' ||
      qcsType === 'OTHER_LIABILITY' ||
      qcsType === 'LOAN';
  }

  // if qcsType is not supported, we are done
  if (!qcsTypeIsSupported) {
    return false;
  }

  // here we want to see if qcsType is supported for the currentNode type
  return !currentNode
    || currentNode.qcsType === 'UNKNOWN'
    || (currentNode.qcsType === 'INVESTMENT' ? node.qcsType === 'INVESTMENT' : node.qcsType !== 'INVESTMENT');
};
/////////

